import Link from 'next/link';

import { Button, cn } from '@holistic/components';

import type { DropdownItem } from '../../constants/user-dropdown-items';

const UserHoverCardItem = ({
  label,
  href,
  onClick,
  icon: Icon,
  variant,
}: DropdownItem) => {
  const isDestructive = variant === 'destructive';

  const content = (
    <>
      <Icon size={15} />
      {label}
    </>
  );

  if (href) {
    return (
      <Button
        variant="ghost"
        className={cn(
          'w-full justify-start gap-3 p-5',
          isDestructive &&
            'text-destructive hover:bg-destructive/10 hover:text-destructive'
        )}
        asChild
      >
        <Link href={href}>{content}</Link>
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      className={cn(
        'w-full justify-start gap-3 p-5',
        isDestructive &&
          'text-destructive hover:bg-destructive/10 hover:text-destructive'
      )}
      onClick={onClick}
    >
      {content}
    </Button>
  );
};

export default UserHoverCardItem;
